module.exports = __webpack_public_path__ + "static/img/gjkj.c23677e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/1M04/gjkj.png
// module id = yxFW
// module chunks = 15